import { getSingleAkte } from 'application/redux/selectors'
const { setSelectedAkte } = require('application/redux/actions/pages/akten')
const { put, select } = require('redux-saga/effects')

export function* setSelectedAkteSaga(action) {
    const resultSingleAkte = yield select(getSingleAkte, action.akteIdHash)
    yield put(setSelectedAkte(resultSingleAkte))
}
